module.exports = __webpack_public_path__ + "img/select-bg.6d9511cb.png";